import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { ShadowDOMElement } from "./fields.js";

export class CommissaireAuxComptesModification extends ShadowDOMElement {
	static className = "CommissaireAuxComptesModification";
	
	static properties = {
		validationRequired: { 
			type: Boolean, 
			attribute: "validation-required",
			converter: {
				fromAttribute: (value) => value === "false" ? false : true,
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};

	constructor() {
		super();
		this.validationRequired = true;
	}

	render() {
		return html`
			<div>
				<!-- Group A: Titulaire -->
				<admin-modification
					id="titulaire"
					title="Commissaire aux comptes / Titulaire"
					title-parting="Commissaire aux comptes / Titulaire"
					text-label-parting="CAC partant *"
					button-label-parting="Ajouter un commissaire aux comptes"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
				></admin-modification>

				<!-- Group B: Suppléant -->
				<admin-modification
					id="suppleant"
					title="Commissaire aux comptes / Suppléant"
					title-parting="Commissaire aux comptes / Suppléant"
					text-label-parting="CAC partant *"
					button-label-parting="Ajouter un commissaire aux comptes"
					validation-text="Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale."
					validation-required="false"
				></admin-modification>
			</div>
		`;
	}

	isTransient() {
		return false;
	}

	getValues() {
		return {
			...super.getValues()
		}
	}

	setValues(values) {
		super.setValues(values);
	}

	validate() {
		// Remove previous validation messages from parent component
		this.shadowRoot.querySelectorAll('.validation-error-message').forEach(el => el.remove());

		// If validation is not required, always return true
		if (!this.validationRequired) {
			return true;
		}

		const titulaireComponent = this.shadowRoot.querySelector('#titulaire');
		const suppleantComponent = this.shadowRoot.querySelector('#suppleant');

		// Check if at least one checkbox is marked in titulaire
		const titulaireCheckboxes = titulaireComponent?.shadowRoot?.querySelectorAll('checkbox-field');
		const titulaireHasChecked = titulaireCheckboxes ? 
			Array.from(titulaireCheckboxes).some(cb => !!cb.checked) : false;

		// Check if at least one checkbox is marked in suppleant
		const suppleantCheckboxes = suppleantComponent?.shadowRoot?.querySelectorAll('checkbox-field');
		const suppleantHasChecked = suppleantCheckboxes ? 
			Array.from(suppleantCheckboxes).some(cb => !!cb.checked) : false;

		// If at least one of the two groups has something marked, it's valid
		if (titulaireHasChecked || suppleantHasChecked) {
			return true;
		}

		// If neither group has checkboxes marked, show error only once
		this.showValidationError();

		return false;
	}

	showValidationError() {
		const errorDiv = document.createElement('div');
		errorDiv.className = 'validation-error-message text-danger d-flex align-items-center mb-3';
		errorDiv.style.paddingLeft = '0px';

		const icon = document.createElement('i');
		icon.className = 'fa-solid fa-circle-exclamation me-2';
		icon.setAttribute('aria-hidden', 'true');

		const text = document.createElement('span');
		text.textContent = 'Vous devez cocher au moins un type de commissaire aux comptes : titulaire ou suppléant, personne physique ou personne morale.';

		errorDiv.appendChild(icon);
		errorDiv.appendChild(text);

		// Insert the message at the beginning of the main container
		const container = this.shadowRoot.querySelector('div');
		if (container && container.firstChild) {
			container.insertBefore(errorDiv, container.firstChild);
		}
	}
}

customElements.define("commissaire-aux-comptes-modification", CommissaireAuxComptesModification);
